/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {confirmArrival} from '../api'

export const useMutationConfirmArrival = createReactQueryMutationHook('confirmArrival', confirmArrival)
